import { z } from 'zod'

export const LocalizedValueZod = z.object({
  en: z.string(),
  fr: z.string(),
})
